<div>
	<mat-card-title>
		Grade Age Alignment
		<help-text-btn class="align-help-text-btn"
			[helpTextId]="'DataMonitoring_GradeAgeAlignment_Overview'"></help-text-btn>
	</mat-card-title>
	<mat-divider> </mat-divider>
	<br>
	<div class="row" style="padding-left:10px;">
		<mat-card appearance="outlined" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" style="min-width:450px;">
			<h3 style="padding-left:18px;padding-top:5px;font-size:large;">
				Search Criteria
			</h3>
			<mat-card-content>
				<region-dropdown-two-way [isMultiple]="true" [(selectedRegions)]="chosenRegions" [reset]="resetField"
					[required]="true" #appRegionCode>
				</region-dropdown-two-way>

				<county-dropdown-two-way [isMultiple]="true" [(selectedCounties)]="chosenCounties" [reset]="resetField"
					[required]="false" #appCountyCode [regions]="chosenRegions">
				</county-dropdown-two-way>

				<district-dropdown-two-way [isMultiple]="true" [(selectedSchoolDistricts)]="chosenSchoolDistricts"
					[reset]="resetField" [required]="false" #appDistrictCode [regions]="chosenRegions"
					[counties]="chosenCounties">
				</district-dropdown-two-way>

				<school-dropdown-two-way [isMultiple]="true" [(selectedSchools)]="chosenSchools" [reset]="resetField"
					#appSchools [regions]="chosenRegions" [counties]="chosenCounties"
					[schoolDistricts]="chosenSchoolDistricts">
				</school-dropdown-two-way>

				<app-school-year [label]="'School Year'" [yearType]="'SchoolYear'"
					(performancePeriodEvent)="schoolYearEvent($event)" [currentYearModifier]="0" [yearsForward]="0"
					[yearsBack]="2" [reset]="resetField" [startingSchoolYearDate]="startingSchoolYearDate">
				</app-school-year>
				<!--	<app-school-year [label]="'Performance Period'" [yearType]="'PerformancePeriod'"
					(performancePeriodEvent)="performancePeriodEvent($event)" [currentYearModifier]="0"
					[yearsForward]="0" [yearsBack]="2" [reset]="resetField"
					[startingSchoolYearDate]="startingSchoolYearDate" *ngIf="currentSetting.PERFORMANCE_PERIOD">
				</app-school-year>-->
			</mat-card-content>
			<mat-card-actions>
				<span style="padding:5px;padding-bottom:10px;">
					<span style="padding-right:15px;">
						<button mat-raised-button color="primary" mat-button [disabled]="isLoading"
							(click)="search()"><!-- !this.checkValid() ||-->
							<mat-icon *ngIf="isLoading">
								<mat-spinner diameter="18"> </mat-spinner>
							</mat-icon>
							Search
						</button>
					</span>
					<span>
						<button mat-raised-button color="accent" (click)="reset()" mat-button>Reset</button>
					</span>
				</span>
			</mat-card-actions>
		</mat-card>
	</div>

	<app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>


	<div *ngIf="results.length > 0" class="margin-top-md">
		<mat-tab-group id="data-monitoring-divided-tab-group" animationDuration="0ms" [(selectedIndex)]="selectedIndex">
			<mat-tab [label]="'Table'">
				<h2>Table Results</h2>
				<span style="float:right;padding:10px;margin-top:-60px;">
					<button [disabled]="!(results.length > 0) || isExporting" mat-raised-button
						[matMenuTriggerFor]="menu" class="margin-right-xs">
						<mat-icon *ngIf="isExporting">
							<mat-spinner diameter="18"> </mat-spinner>
						</mat-icon>
						Export
						<mat-icon *ngIf="!isExporting">more_vert</mat-icon>
					</button>
					<mat-menu #menu="matMenu">
						<button mat-menu-item (click)="downloadExcelTable()">
							<span>
								<i class="fa fa-file"></i>
								Export Table</span>
						</button>
						<button mat-menu-item (click)="downloadExcelStudents()">
							<span>
								<i class="fa fa-file"></i>
								Export List</span>
						</button>
					</mat-menu>
				</span>

				<div class="margin-top-sm table-responsive">
					<mat-table id="grade-age-alignment-table" [dataSource]="gradeAgeAlignmentDataSource"
						class="mat-elevation-z1" #firstTabTable>
						<ng-container matColumnDef="header-row-grade-level">
							<mat-header-cell *matHeaderCellDef [attr.colspan]="27" class="justify-center">
								Grade Level
							</mat-header-cell>
						</ng-container>

						<ng-container matColumnDef="AGE">
							<mat-header-cell *matHeaderCellDef> Age on 9/1/{{this.currentSchoolYear.substring(0, 4)}}
							</mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.AGE}} </mat-cell>
						</ng-container>

						<ng-container *ngFor="let grade of gradeOptions" [matColumnDef]="grade.GRADES">
							<mat-header-cell *matHeaderCellDef> {{grade.GRADES}} </mat-header-cell>
							<mat-cell *matCellDef="let element" [class]="element[grade.GRADES].CLASS"
								[ngClass]="{'cursor-pointer': element[grade.GRADES].COUNT > 0}"
								(click)="element[grade.GRADES].COUNT > 0 ? openStudentDialog(grade.GRADES, element.AGE) : null">
								<span>{{(element[grade.GRADES].COUNT
									=== 0 ?
									'' : element[grade.GRADES].COUNT) | number}}</span>
							</mat-cell>
						</ng-container>

						<mat-header-row *matHeaderRowDef="['header-row-grade-level']"></mat-header-row>
						<mat-header-row *matHeaderRowDef="gradeAgeAlignmentColumns"></mat-header-row>
						<mat-row *matRowDef="let row; columns: gradeAgeAlignmentColumns;">
						</mat-row>
					</mat-table>

					<!-- <p>&nbsp;</p>
					HERE:    

					<view-grade-intersect></view-grade-intersect>
	                <view-grade-alignmt-table #appViewGradeAgeAlignmentTable>This is it</view-grade-alignmt-table>    -->
				</div>

				<div class="margin-top-md">
					<div class="bold">
						Legend:
					</div>
					<div class="margin-top-xs">
						Light gray cells/normal font - appropriate grade, or one year over or under age
					</div>
					<div class="margin-top-xs">
						Dark gray cells/italics - more than one year over age
					</div>
					<div class="margin-top-xs">
						Orange cells/italics and bold - possible data errors
					</div>
				</div>
			</mat-tab>
			<mat-tab [label]="'Individual Children'">
				<div style="overflow-x:hidden;">
					<h2>
						Search Results - {{'(' + currentSchoolYear + ')'}} - ({{(searchResultDataSource ?
						(searchResultDataSource.filteredData.length < results.length ?
							searchResultDataSource.filteredData.length + '/' : '' ) : '' ) + results.length}} Children)
							</h2>

							<span style="float:right;padding:10px;margin-top:-60px;">
								<button [disabled]="!(results.length > 0) || isExporting" mat-raised-button
									[matMenuTriggerFor]="menu" class="margin-right-xs">
									<mat-icon *ngIf="isExporting">
										<mat-spinner diameter="18"> </mat-spinner>
									</mat-icon>
									Export
									<mat-icon *ngIf="!isExporting">more_vert</mat-icon>
								</button>
								<mat-menu #menu="matMenu">
									<button mat-menu-item (click)="downloadExcelTable()">
										<span>
											<i class="fa fa-file"></i>
											Export Table</span>
									</button>
									<button mat-menu-item (click)="downloadExcelStudents()">
										<span>
											<i class="fa fa-file"></i>
											Export List</span>
									</button>
								</mat-menu>
							</span>
							<hr />

							<div class="row">
								<mat-form-field>
									<mat-label>
										Filter
									</mat-label>
									<input matInput id="filter" name="filter" type="string"
										[(ngModel)]="searchResultFilter"
										(ngModelChangeDebounced)="setFilter(searchResultDataSource, searchResultFilter)" />
								</mat-form-field>
							</div>

							<div class="margin-top-sm">

								<mat-table [dataSource]="searchResultDataSource"
									class="mat-elevation-z1 table-responsive" style="table-layout:fixed; width:100%;"
									matSort> <!-- style=""-->

									<ng-container matColumnDef="SCHOOL.REGIONS.CODE">
										<mat-header-cell *matHeaderCellDef mat-sort-header> Region </mat-header-cell>
										<mat-cell *matCellDef="let element"> {{element.SCHOOL.REGIONS.CODE}} </mat-cell>
									</ng-container>

									<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].SCHOOL_YEAR">
										<mat-header-cell *matHeaderCellDef mat-sort-header> School Year
										</mat-header-cell>
										<mat-cell *matCellDef="let element">
											{{element.SCHOOL_ENROLLMENT_DETAILS[0].SCHOOL_YEAR}}
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="SCHOOL.SCHOOL_DISTRICT.DISTRICTS">
										<mat-header-cell *matHeaderCellDef mat-sort-header> District </mat-header-cell>
										<mat-cell *matCellDef="let element"> {{element.SCHOOL.SCHOOL_DISTRICT.DISTRICTS
											|
											titlecase}}
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="SCHOOL.NAME">
										<mat-header-cell *matHeaderCellDef mat-sort-header> School </mat-header-cell>
										<mat-cell *matCellDef="let element"> {{element.SCHOOL.NAME | titlecase}}
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="SCHOOL.cdscODE">
										<mat-header-cell *matHeaderCellDef mat-sort-header> School CDS Code
										</mat-header-cell>
										<mat-cell *matCellDef="let element"> {{element.SCHOOL.cdscODE}} </mat-cell>
									</ng-container>

									<ng-container matColumnDef="MSD_NUMBER">
										<mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number
										</mat-header-cell>
										<mat-cell *matCellDef="let element">
											<edit-child-modal-btn [studentId]="element.ID" [type]="'string'"
												[displayText]="element.MSD_NUMBER">
											</edit-child-modal-btn>
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="SSID">
										<mat-header-cell *matHeaderCellDef mat-sort-header> SSID </mat-header-cell>
										<mat-cell *matCellDef="let element"> {{element.SSID}}</mat-cell>
									</ng-container>

									<ng-container matColumnDef="PERSON.LAST_NAME">
										<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
										<mat-cell *matCellDef="let element"> {{element.PERSON.LAST_NAME |
											titlecase}}{{(element.SECOND_LAST_NAME
											? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}}
											{{element.PERSON.FIRST_NAME |
											titlecase}}
											{{element.PERSON.MIDDLE_INITIAL | titlecase}}</mat-cell>
									</ng-container>

									<ng-container matColumnDef="DOB">
										<mat-header-cell *matHeaderCellDef mat-sort-header> DOB </mat-header-cell>
										<mat-cell *matCellDef="let element"> {{element.DOB | simpleDate}}
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="AGE">
										<mat-header-cell *matHeaderCellDef mat-sort-header> Age </mat-header-cell>
										<mat-cell *matCellDef="let element"> {{element.AGE}}
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].GRADE">
										<mat-header-cell *matHeaderCellDef mat-sort-header> Grade </mat-header-cell>
										<mat-cell *matCellDef="let element"> {{(element.SCHOOL_ENROLLMENT_DETAILS ?
											element.SCHOOL_ENROLLMENT_DETAILS[0].GRADE : '')}}
										</mat-cell>
									</ng-container>

									<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
									<mat-row *matRowDef="let row; columns: displayedColumns;"
										[ngClass]="{'terminatedRow': row.STUDENT_TERMINATION_STATUSES?.length > 0 && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID !== 1}"
										[matTooltip]="row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE"
										[matTooltipPosition]="'above'"
										[matTooltipDisabled]="row.STUDENT_TERMINATION_STATUSES?.length === 0 || (row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID === 1)"
										[matTooltipClass]="'terminatedTooltip'">
									</mat-row>
								</mat-table>

								<mat-paginator style="overflow-x:hidden;" #paginators [pageSizeOptions]="[5, 10, 20]"
									showFirstLastButtons aria-label="Select page of periodic elements">
								</mat-paginator>

							</div>
				</div>
			</mat-tab>
		</mat-tab-group>
	</div>
</div>